// extracted by mini-css-extract-plugin
export var fadeInOut = "_n-3";
export var icon = "_n-4";
export var savedIndicator = "_n-2";
export var savingIndicator = "_n-0";
export var spin = "_n-1";